import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { getWhitelabels } from "../Redux/Action";

export const useInitializeWhitelabel = () => {
  const dispatch = useDispatch();

  useEffect(() => {
   
    
    const domain = new URL(window.location.href).origin;
    console.log("domain",domain)
    dispatch(
      getWhitelabels({
        payload: domain
      })
    );
  }, [dispatch]);
};
